

























































































import { Component, Prop, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";
import HtmlFunctions from "@/common/HtmlFunctions";

import DateAndTime from "@/components/DateAndTime.vue";

@Component({
    computed: mapGetters({
        isAuthenticated: "auth/isAuthenticated",
        isAdmin: "auth/isAdmin"
    }),
    components: {
        DateAndTime
    }
})
export default class Nav extends Vue {
    isFullScreen: boolean = false;

    logoff() {
        this.$store.dispatch("auth/authLogout").then(() => {
            this.$store.dispatch("app/setMenu", false);
            this.$router.push("/login");
        });
    }

    toggleFullScreen() {
        this.isFullScreen = !this.isFullScreen;
        if (this.isFullScreen) {
            HtmlFunctions.openFullScreen();
        } else {
            HtmlFunctions.closeFullscreen();
        }
    }
}
